<template>
  <DashboardVideo />
  <div class="container d-flex align-items-center justify-content-center z-2">
    <div class="row mobile align-content-between g-0">
      <div
        class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-between theme-header"
      >
        <a
          href="https://tool.metaluxe.com.au/"
          target="_blank"
          data-bs-toggle="tooltip"
          title="Click to Edits"
        >
          <img src="/img/ui-theme/key.svg" height="30"
        /></a>

        <img :src="`/img/ui-theme/` + theme.devLogo" class="logo" />

        <button
          class="btn"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          style="padding-right: 0; padding-left: 0"
        >
          <img
            src="/img/ui-theme/contact-icon-rev.svg"
            height="30"
            alt="Fullscreen"
          />
        </button>
      </div>
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link
              v-if="assetTypes"
              :to="{
                name: 'VideoView',
                params: {
                  guid: '3a258150-9854-49b3-b567-ba5aab23e644',
                  collectionId: '539370',
                },
              }"
              class="border-top-right-radius border-bottom-left-radius btn-theme-menu mb-2 flex"
            >
              <span className="video-label flex-1 ">Presents</span>
            </router-link>
            <a
              href="https://50sunset.metaluxe.com.au/"
              target="_blank"
              class="btn-theme-menu mb-2"
              >Pre Da / Design Package</a
            >
            <router-link
              :to="{
                name: this.componentName,
                params: {
                  assetType: 'media-packages',
                },
              }"
              :class="['btn-theme-menu', 'mb-2']"
            >
              Media Packages
            </router-link>
          </div>
        </div>
      </div>
      <div
        class="col-12 d-flex align-items-end justify-content-end sticky-bottom theme-footer"
      ></div>
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "DashboardHome",
  components: {
    DashboardVideo,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      componentName: "AssetType",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/plusstudio/"
      ),
    };
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });
        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.theme.assetsMenuOrder,
          },
        });

        this.assetTypes = customMenu;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    formatTitle: function (title) {
      return title.replace("Design", "Design -");
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
